// Helpers for the direct-enrollment funnel (CPP parsing, order estimates, currency).

export const parseCPP = (cpp) => {
  if (cpp == null) return 0;
  const nums = String(cpp).match(/\d+/g);
  if (!nums || nums.length === 0) return 0;
  const arr = nums.map(Number);
  const mid = arr.reduce((a, b) => a + b, 0) / arr.length;
  return Math.round(mid);
};

// Auto-calculated average orders for a given ad spend, based on CPP (cost per purchase).
export const ordersFromSpend = (spend, cpp) => {
  const c = parseCPP(cpp);
  if (!c) return 0;
  return Math.max(0, Math.floor(Number(spend || 0) / c));
};

export const formatINR = (n) => `\u20b9${Number(n || 0).toLocaleString('en-IN')}`;

// WhatsApp support number for payment screenshot sharing
export const SUPPORT_WHATSAPP = '918819001865';
